module.exports = __webpack_public_path__ + "img/pc_old.c53105f7.png";